import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import plus from "../../Components/assets/icons/a1.png";
import colunms from "../../Components/assets/icons/LINES.png";
import pen from "../../Components/assets/icons/pen.png";
import eye from "../../Components/assets/icons/eye.png";
import basket from "../../Components/assets/icons/basket.png";
import search1 from "../../Components/assets/icons/search.png";
import top from "../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import circle from "../assets/icons/circle.png";
import rigth from "../assets/icons/rigth.png";
import save from "../assets/icons/save.png";
import cancel from "../assets/icons/cross.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../Header/Header";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Offcanvas from "react-bootstrap/Offcanvas";
import classNames from "classnames";
import toast, { Toaster } from "react-hot-toast";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Context } from "../../utils/context";
import { FaEye } from "react-icons/fa";
import { formatDate } from "../../utils/common";
import { Controller, useForm } from "react-hook-form";
import ViewOffCanvance from "./ViewOffCanvance";
import { Modal } from "react-bootstrap";
import ModalSave from "../common/ModelSave";
import { AddButton, EditButton, DeletButton } from "../common/Button";
import Pagination_Holder from "../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import EditOffCanvanceCharges from "../Booking/EditCharges";
import AddOffCanvanceCharges from "../Booking/AddCharges";

library.add(fas);

// ********************************************************************************************************************************************************

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    IMG_URL,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    postData,
    getDownloadDataExcel,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [resets, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [showCharges, setShowAddCharges] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [show1Charges, setShowEditCharges] = useState(0);
  const [option, setOption] = useState();
  const [searchByUser, setSearchByUser] = useState(null);
  const [vender, setvender] = useState("");
  const [studioName, setStudioName] = useState("");
  const [totalPages, setTotalPages] = useState();
  const { id } = useParams();

  useEffect(() => {
    setSearchByUser(id || null); // Set to null if id is undefined or null
    getDataAll();
  }, [id]);

  useEffect(() => {
    getDataAll();
  }, [searchByUser]);

  const [user, setUser] = useState({});
  const GetUserData = async () => {
    const response = await getData(`/usersingleget`);
    if (response?.success) {
      console.log("user :-", response?.data);
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetUserData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
    getValues,
  } = useForm();

  // console.log(getValues("type").value, "Type");

  const type = [
    {
      value: "Hourly",
      label: "Hourly",
    },
    {
      value: "Daily",
      label: "Daily",
    },
  ];

  const [changeStatus, setChangeStatus] = useState();
  const [changeStatusTopStudio, setChangeStatusTopStudio] = useState();
  const [changeStatusPremiumStudio, setChangeStatusPremiumStudio] = useState();
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [onPageChange, setonPageChange] = useState(1);
  const [fromDaily, setFromDaily] = useState("");
  const [toDaily, setToDaily] = useState("");
  const [searchPaymentStatus, setSearchPaymentSatatus] = useState("");
  const [searchCategory, setSearchCategory] = useState("");
  const [searchSubCategory, setSearchSubCategory] = useState("");
  const [searchBookingId, setSearchBookingId] = useState("");

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  const getDataAll = async () => {
    const queryString = `/booking/app-booking?page=${onPageChange}&per_page=${perPage}&term=${search}&vender=${
      vender || ""
    }&studioName=${studioName || ""}&from=${from ? formatDate(from) : ""} &to=${
      to ? formatDate(to) : ""
    }&searchPaymentStatus=${searchPaymentStatus?.value || ""}&fromdaily=${
      fromDaily ? formatDate(fromDaily) : ""
    } &todaily=${toDaily ? formatDate(toDaily) : ""}&searchCategory=${
      searchCategory?.value || ""
    }&searchSubCategory=${searchSubCategory?.value || ""}&searchBookingId=${
      searchBookingId?.value || ""
    }`;
    const response = await getData(queryString);
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    setTotalPages(response?.data?.totalPages);
    console.log("response", response);
    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };
  useEffect(() => {
    getDataAll();
  }, [
    changeStatus,
    changeStatusTopStudio,
    changeStatusPremiumStudio,
    perPage,
    resets,
    show,
    show1,
    showCharges,
    show1Charges,
    // search,
    // studioName,
    // vender,
    // from,
    // to,
    // fromDaily,
    // toDaily,
    onPageChange,
    // searchPaymentStatus,
    // searchCategory,
    // searchSubCategory,
    // searchBookingId,
  ]);

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/studio/${id}`);
    setChangeStatus(response);
  };

  const ChangeStatusTopStudio = async (id) => {
    const response = await editStatusData(`/studio/top-studio-status/${id}`);
    setChangeStatusTopStudio(response);
  };

  const ChangeStatusPremiumStudio = async (id) => {
    const response = await editStatusData(
      `/studio/premium-studio-status/${id}`
    );
    setChangeStatusPremiumStudio(response);
  };

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  const [bookingId, setBookingId] = useState([]);

  const GetAllCategory = async () => {
    const response = await getData("/allcategories");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "category_id"));
    }
  };

  const Select3Data = async (data, name, other = false) => {
    const result = data.map((data) => ({
      value: data?.id,
      label: data?.booking_id,
      name: name,
    }));

    if (other) {
      result.push({ value: "0", label: "Other", name: name });
    }
    return result;
  };

  const GetAllBookingId = async () => {
    const response = await getData("/all-booking-id");
    if (response?.success) {
      setBookingId(await Select3Data(response?.data, "booking_id"));
    }
  };

  const GetAllSubCategory = async (id) => {
    const response = await getData(`/allsubcategories/${id}`);
    if (response?.success) {
      setSubCategories(await Select2Data(response?.data, "sub_category_id"));
    }
  };

  useEffect(() => {
    GetAllCategory();
  }, []);

  useEffect(() => {
    GetAllBookingId();
  }, [searchBookingId]);

  // Delete module.....................................................
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);

  const handleCloseCharges = () => setShowAddCharges(false);
  // const handleShow = () => setShowAdd(true);

  const handleShow = (id, name) => {
    setCabType(name);
    setShowAdd(true);
    setSelectedId(id);
  };

  const handleShowCharges = (id, name) => {
    setCabType(name);
    setShowAddCharges(true);
    setSelectedId(id);
  };
  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id, name) => {
    setCabType(name);
    setShowEdit(id);
  };
  const handleClose1Charges = () => setShowEditCharges(0);
  const handleShow1Charges = (id, name) => {
    setCabType(name);
    setShowEditCharges(id);
  };

  const DeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/studio/${recordToDeleteId}`);
      await ErrorNotify(recordToDeleteName);
      setChangeStatus(response);
      setRecordToDeleteId(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
  };

  //toggle/
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
    col11: true,
    col12: true,
    col13: true,
    col14: true,
    col15: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const HandleDownload = async () => {
    if (selectAllChecked.length == 0) {
      alert("Please Select Atleast One Record");
    } else {
      try {
        await getDownloadDataExcel(
          "/booking/download",
          selectAllChecked,
          "Booking list"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const [cities, setCities] = useState([]);

  const [childSubCategories, setChildSubCategories] = useState([]);

  const GetAllCities = async () => {
    const response = await getData("/allcity");
    if (response?.success) {
      setCities(await Select2Data(response?.data, "city_id"));
    }
  };

  useEffect(() => {
    GetAllCities();
  }, []);

  const handleDownload = async (invoice) => {
    try {
      // const response = await getData(`/order/invoice-download/${id}`);

      const filePath = invoice;

      if (!filePath) {
        console.error("File path is undefined or null");
        return;
      }

      const url = `${IMG_URL}/${filePath}`;

      // Create an invisible link element and open the file in a new tab
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank"; // Open in a new tab
      a.rel = "noopener noreferrer"; // Recommended for security reasons
      a.click();
    } catch (error) {
      console.error("Error opening file:", error);
    }
  };

  const [view, setview] = useState(0);
  const handleViewClose = () => setview(false);
  const handleViewshow = async (id, name) => {
    // setCabType(name);
    console.log(id);
    await setview(id);
  };
  const [selectedId, setSelectedId] = useState();
  const [cabType, setCabType] = useState();
  const [modalShowAmount, setModalShowAmount] = useState(false);
  const Accepted = (id) => {
    setSelectedId(id); // Store the selected ID to access inside the modal
    setModalShowAmount(true); // Open the modal
  };

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const onSubmit = async (data) => {
    try {
      console.log(data);
      const finalData = new FormData();
      finalData.append("booking_id", selectedId);
      finalData.append("reason", data?.reason);

      const response = await postData(
        `/booking/cancel/${selectedId}`,
        finalData
      );
      console.log(response);
      if (response?.success) {
        getDataAll();
        setSelectedId("");
        setModalShowAmount(false);
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [dataDriver, setDataDriver] = useState();
  const GetEditData = async () => {
    const response = await getData(`/booking/driver/${selectedId}`);
    setDataDriver(response?.data);
    reset(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, [selectedId]);

  const handleClearData = () => {
    reset(); // Clears all form fields
  };

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  useEffect(() => {
    getDataAll(currentPage);
  }, []);
  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Booking"} link={"/studio"} />
        <section className="AdvanceDashboard">
          <div className="col-xxl-12 col-xl-12  ">
            <div className="row MainRowsec">
              <section className="Tabels tab-radio tab-radio">
                <div className="">
                  {/* container */}
                  <div className="row">
                    {/* {isAllow.includes(100) ? (
                      <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12">
                        <Link
                          // to="/employee/employee_details/add"
                          type="button"
                          className="btn btn-add pe-3"
                        >
                          <div className="add me-3">
                            <div onClick={() => handleShow()}>
                              <p className="add-sub-txttt">
                                {" "}
                                <img
                                  src={plus}
                                  className="plus me-2 ms-0"
                                  alt=""
                                />
                                Add Studio
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : (
                      <></>
                    )} */}
                   
                    <div className="border-line mt-3"></div>
                    <div className="row mt-4">
                      <div className=" col-md-12 col-12">
                        <div className="d-flex mb-3 align-items-center">
                          <div className="show me-2">
                            <p className="show m-0">Show</p>
                          </div>
                          <div className="number me-2">
                            <select
                              className="form-select form-select-sm"
                              aria-label=".form-select-sm example"
                              onChange={(e) => setperPage(e.target.value)}
                            >
                              {option?.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="entries">
                            <p className="show  m-0">entries</p>
                          </div>
                          <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12">
                            <div className="sowing me-2 ms-3">
                              <p className="show  m-0">{`Showing ${Math.min(
                                (currentPage - 1) * perPage + 1
                              )} to ${Math.min(
                                currentPage * perPage,
                                data?.data?.totalEntries
                              )} of ${data?.data?.totalEntries} entries`}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xxl-12 col-xl-12  col-lg-12  col-md-12 col-12">
                        <div className="row">
                          <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                            <Form.Label>Customer Name</Form.Label>
                            <div className="num me-2 text-end">
                              <input
                                type="text"
                                className="form-control"
                                id=""
                                placeholder="customer name"
                                value={search}
                                onChange={(e) => {
                                  setSearch(e.target.value);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-sm-12 col-12  mb-3">
                            <Form.Label> Payment Status</Form.Label>
                            <div className="num me-2">
                              <Select
                                options={[
                                  { label: "COD", value: "COD" },
                                  { label: "Online", value: "Online" },
                                ]}
                                // value={searchPaymentStatus}
                                placeholder="Payment Status"
                                value={searchPaymentStatus}
                                onChange={(e) => {
                                  setSearchPaymentSatatus(e);
                                }}
                                classNamePrefix="searchProduct"
                              />
                            </div>
                          </div>
                          <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                            <Form.Label> From</Form.Label>
                            <div className="num me-2 text-end">
                              <input
                                type="date"
                                className="form-control"
                                value={fromDaily}
                                onChange={(e) => {
                                  setFromDaily(e.target.value);
                                  setToDaily(""); // Reset the "Daily To" date when "Daily From" changes
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                            <Form.Label> To</Form.Label>
                            <div className="num me-2 text-end">
                              <input
                                type="date"
                                className="form-control"
                                value={toDaily}
                                onChange={(e) => setToDaily(e.target.value)}
                                min={fromDaily}
                              />
                            </div>
                          </div>
                          <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                            <Form.Label> Category</Form.Label>
                            <div className="num me-2">
                              <Select
                                isSearchable
                                options={categories}
                                value={searchCategory}
                                placeholder="Select Category"
                                onChange={(e) => {
                                  setSearchCategory(e);
                                  GetAllSubCategory(e.value);
                                  setSearchSubCategory("");
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                            <Form.Label>Sub Category</Form.Label>
                            <div className="num me-2">
                              <Select
                                isSearchable
                                options={subCategories}
                                value={searchSubCategory}
                                placeholder="Select Sub Category"
                                onChange={(e) => {
                                  setSearchSubCategory(e);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                            <Form.Label>Booking ID</Form.Label>
                            <div className="num me-2">
                              <Select
                                isSearchable
                                options={bookingId}
                                value={searchBookingId}
                                placeholder="Select BookingId"
                                onChange={(e) => {
                                  setSearchBookingId(e);
                                }}
                              />
                            </div>
                          </div>
                          <div className="d-flex col-xxl-3 col-xl-3  col-lg-4  col-md-5 col-12 mb-2 mt-3">
                            <button
                              type="button"
                              className="btn btn-search w-100"
                              onClick={HandleDownload}
                            >
                              Download excel
                              <FontAwesomeIcon
                                icon="fa-solid fa-file-lines"
                                className="pdf-icon ms-3"
                                variant="success"
                                // className="btn btn-view"
                              />
                            </button>
                          </div>
                          <div className="col-xxl-1 col-xl-1 col-lg-2 col-md-2 col-sm-6 col-12 ">
                            <Form.Label></Form.Label>
                            <div className="Search-1">
                              <Button
                                type="button"
                                onClick={getDataAll}
                                className="btn btn-search w-100"
                              >
                                <img src={search1} className="search" alt="" />
                              </Button>
                            </div>
                          </div>{" "}
                          <div className="col-xxl-1 col-xl-1 col-lg-2 col-md-2 col-sm-6 col-12 ">
                            <Form.Label></Form.Label>
                            <div className="Search-1">
                              <button
                                type="button"
                                onClick={() => {
                                  setSearch("");
                                  setStudioName("");
                                  setvender("");
                                  setTo("");
                                  setFrom("");
                                  setFromDaily("");
                                  setToDaily("");
                                  setSearchSubCategory("");
                                  setSearchCategory("");
                                  setSearchPaymentSatatus("");
                                  setSearchBookingId("");
                                  setReset(!resets);
                                }}
                                className="btn btn-reset w-100"
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                          {/* {usertype == "Admin" ? (
                            <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                              <div className="num me-2 text-end">
                                <input
                                  type="text"
                                  className="form-control"
                                  id=""
                                  placeholder="vendor"
                                  value={vender}
                                  onChange={(e) => {
                                    setvender(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          ) : (
                            ""
                          )} */}
                          {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                            <div className="num me-2 text-end">
                              <input
                                type="text"
                                className="form-control"
                                id=""
                                placeholder="studio name"
                                value={studioName}
                                onChange={(e) => {
                                  setStudioName(e.target.value);
                                }}
                              />
                            </div>
                          </div> */}
                          {/* <div className="Search me-2">
                            <Button
                              type="button"
                              onClick={getDataAll}
                              className="btn btn-search"
                            >
                              <img src={search1} className="search" alt="" />
                            </Button>
                          </div> */}
                        </div>

                        {/* <div className="row">
                          {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                            <div className="main-form-section">
                              <Row className="row justify-content-center mb-2">
                                <Form.Label> Type</Form.Label>
                                <Controller
                                  name="type"
                                  control={control}
                                  rules={{ required: "Select Brand" }}
                                  render={({ field }) => (
                                    <Select
                                      styles={{
                                        control: (baseStyles) => ({
                                          ...baseStyles,
                                          borderColor: errors.type
                                            ? "red"
                                            : baseStyles.borderColor,
                                        }),
                                      }}
                                      {...field}
                                      options={type}
                                      onChange={(selectedOption) => {
                                        field.onChange(selectedOption.value);
                                        setValue("type", selectedOption);
                                        reset(getValues());
                                      }}
                                    />
                                  )}
                                />
                                {errors.type && (
                                  <span className="text-danger">
                                    {errors.type.message}
                                  </span>
                                )}
                              </Row>
                            </div>
                          </div> */}

                        {/* </div>  */}
                      </div>
                    </div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table bordered hover responsive center>
                        <thead>
                          <tr className="">
                            {visible.col0 && (
                              <th className="check round-check">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="selectAll"
                                    checked={
                                      allChecked.length ===
                                      selectAllChecked.length
                                    }
                                    onChange={handleChange}
                                    id="selectAll"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexCheckChecked"
                                  ></label>
                                </div>
                              </th>
                            )}
                            {visible.col1 && <th className="sr">S. No.</th>}
                            {visible.col2 && (
                              <th
                                style={{ width: "400px" }}
                                className="tax-name"
                              >
                                BookingID
                              </th>
                            )}

                             {visible.col2 && (
                              <th
                                style={{ width: "400px" }}
                                className="tax-name"
                              >
                               App BookingID
                              </th>
                            )}
                            {visible.col3 && (
                              <th
                                style={{ width: "400px" }}
                                className="tax-name"
                              >
                                Customer Name
                              </th>
                            )}
                            {visible.col4 && (
                              <th
                                style={{ width: "400px" }}
                                className="tax-name"
                              >
                                Distance
                              </th>
                            )}
                            {visible.col6 && (
                              <th
                                style={{ width: "600px" }}
                                className="tax-name"
                              >
                                Total Fare
                              </th>
                            )}
                            {visible.col7 && (
                              <th
                                style={{ width: "400px" }}
                                className="tax-name"
                              >
                                Cab Type
                              </th>
                            )}
                            {/* {visible.col14 && (
                              <th
                                style={{ width: "400px" }}
                                className="tax-name"
                              >
                                Cab Name
                              </th>
                            )} */}
                            {visible.col8 && (
                              <th
                                style={{ width: "400px" }}
                                className="tax-name"
                              >
                                Date
                              </th>
                            )}
                            {visible.col9 && (
                              <th
                                style={{ width: "400px" }}
                                className="tax-name"
                              >
                                Time
                              </th>
                            )}{" "}
                            {visible.col15 && (
                              <th className="tax-name">Driver Note</th>
                            )}
                            {visible.col10 && (
                              <th
                                style={{ width: "400px" }}
                                className="tax-name"
                              >
                                Payment Status
                              </th>
                            )}
                            {/* {visible.col11 && (
                              <th
                                style={{ width: "400px" }}
                                className="tax-name"
                              >
                                Category
                              </th>
                            )} */}
                            {visible.col12 && (
                              <th className="tax-name">SubCategory</th>
                            )}
                            {visible.col13 && (
                              <th
                                style={{ width: "400px" }}
                                className="tax-name"
                              >
                                Action
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {/* {isAllow.includes(5) ? ( */}
                          {data?.data?.data?.length > 0 ? (
                            data.data.data.map((d, index) => {
                              let bgColor = "";
                              if (
                                d?.driver_detail === null &&
                                d?.booking_charge === null
                              ) {
                                bgColor = "#d4edda";
                              } else if (
                                d?.driver_detail !== null &&
                                d?.booking_charge === null
                              ) {
                                bgColor = "#e6f3b8ff";
                              } else {
                                bgColor = "#f0f0f0";
                              }
                              return (
                                <tr
                                  className=""
                                  key={index}
                                  style={{ backgroundColor: bgColor }}
                                >
                                  {visible.col0 && (
                                    <td>
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value={d?.id}
                                          name="perselected"
                                          checked={selectAllChecked.includes(
                                            d?.id
                                          )}
                                          onChange={handleChange}
                                          id="flexCheckDefault"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="flexCheckDefault"
                                        ></label>
                                      </div>
                                    </td>
                                  )}
                                  {visible.col1 && <td>{++index}.</td>}
                                  {visible.col2 && <td>{d?.booking_id}</td>}
                                    {visible.col2 && <td>{d?.app_booking_id}</td>}
                                  {visible.col3 && (
                                    <td>{d?.user?.first_name}</td>
                                  )}
                                  {visible.col4 && <td>{d?.distance} Km</td>}
                                  {/* {visible.col5 && <td>{d?.duration}</td>} */}
                                  {visible.col6 && <td>₹{d?.fare}</td>}
                                  {visible.col7 && <td>{d?.cab_type?.name}</td>}
                                  {/* {visible.col14 && <td>{d?.cab?.name}</td>} */}
                                  {visible.col8 && (
                                    <td>
                                      {new Date(d?.date).toLocaleDateString(
                                        "en-GB",
                                        {
                                          day: "2-digit",
                                          month: "2-digit",
                                          year: "2-digit",
                                        }
                                      )}
                                    </td>
                                  )}

                                  {visible.col9 && <td>{d?.time}</td>}
                                  {visible.col15 && <td>{d?.note || "NA"}</td>}
                                  {visible.col10 && (
                                    <td>
                                      <div className="d-flex">
                                        <td>{d?.payment_method}</td>
                                      </div>
                                    </td>
                                  )}
                                  {/* {visible.col11 && (
                                    <td>
                                      <div className="d-flex">
                                        <td>{d?.category?.name}</td>
                                      </div>
                                    </td>
                                  )} */}

                                  {visible.col12 && (
                                    <td>
                                      <div className="d-flex">
                                        <td>{d?.sub_category?.name}</td>
                                      </div>
                                    </td>
                                  )}

                                  {visible.col13 && (
                                    <td>
                                      <div className="d-flex">
                                        <div className="add me-3">
                                          {" "}
                                          <Link
                                            type="button"
                                            className="btn btn-add pe-3 "
                                          >
                                            <div
                                              onClick={() =>
                                                handleViewshow(d.id)
                                              }
                                            >
                                              view
                                            </div>
                                          </Link>
                                        </div>
                                        {d?.booking_status_id === 2 ? (
                                          d?.booking_status?.name // Removed the extra braces
                                        ) : (
                                          <div className="d-flex">
                                            <div className="add me-3">
                                              <button
                                                onClick={() => {
                                                  Accepted(d.id);
                                                }}
                                                type="button"
                                                className="btn btn-primary bg-danger border-danger mb-3  "
                                              >
                                                Reject
                                              </button>
                                            </div>
                                          </div>
                                        )}
                                        {d?.driver_detail !== null ? (
                                          <div className="add me-3">
                                            <button
                                              onClick={() => {
                                                handleShow1(
                                                  d?.id,
                                                  d?.cab_type?.name
                                                );
                                              }}
                                              type="button"
                                              className="btn btn-warning mb-3 "
                                            >
                                              Edit
                                            </button>
                                          </div>
                                        ) : (
                                          // <EditButton handleShow1={handleShow1} id={d?.id} />
                                          <div className="add me-3">
                                            <button
                                              onClick={() => {
                                                handleShow(
                                                  d?.id,
                                                  d?.cab_type?.name
                                                );
                                              }}
                                              type="button"
                                              className="btn btn-success mb-3 "
                                            >
                                              Add
                                            </button>
                                          </div>
                                        )}
                                        {d?.booking_charge !== null && (
                                          <div className="add me-3">
                                            <button
                                              onClick={() =>
                                                handleDownload(d?.invoice)
                                              }
                                              className="btn btn-primary mb-3"
                                            >
                                              Download
                                            </button>
                                          </div>
                                        )}

                                        {d?.booking_charge !== null ? (
                                          <div className="add me-3">
                                            <button
                                              onClick={() => {
                                                handleShow1Charges(
                                                  d?.id,
                                                  d?.cab_type?.name
                                                );
                                              }}
                                              type="button"
                                              className="btn btn-success mb-3 "
                                            >
                                              Edit Charges
                                            </button>
                                          </div>
                                        ) : (
                                          // <EditButton handleShow1={handleShow1} id={d?.id} />
                                          <div className="add me-3">
                                            <button
                                              onClick={() => {
                                                handleShowCharges(
                                                  d?.id,
                                                  d?.cab_type?.name
                                                );
                                              }}
                                              type="button"
                                              className="btn btn-success mb-3 "
                                            >
                                              Add Charges
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="20" className="text-center">
                                No Data
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Pagination_Holder
                        onPageChange={currentPage}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
          selectedId={selectedId}
          cabType={cabType}
        />
      ) : (
        ""
      )}

      {showCharges ? (
        <AddOffCanvanceCharges
          handleClose={handleCloseCharges}
          setShow={setShowAddCharges}
          show={showCharges}
          selectedId={selectedId}
          cabType={cabType}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
          cabType={cabType}
        />
      ) : (
        ""
      )}
      {show1Charges ? (
        <EditOffCanvanceCharges
          handleClose={handleClose1Charges}
          setShow={handleShow1Charges}
          show={show1Charges}
          cabType={cabType}
        />
      ) : (
        ""
      )}

      {view ? (
        <ViewOffCanvance
          handleClose={handleViewClose}
          setShow={setview}
          show={view}
          id={view}
          getDataAll={getDataAll}
        />
      ) : (
        ""
      )}

      <Toaster position="top-right" />

      {/* <!-- Modal Delete --> */}
      <Modal
        show={modalShowAmount}
        onHide={() => {
          setModalShowAmount(false);
          handleClearData(); // Clear the data
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Cancel Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="form-group">
              <Form.Label>Reason</Form.Label>
              <Form.Control
                type="text"
                name="reason"
                placeholder="Name .."
                className={classNames("", {
                  "is-invalid": errors?.reason,
                })}
                {...register("reason", {
                  required: "reason is required",
                })}
              />
              {errors.reason && (
                <span className="text-danger">{errors.reason.message}</span>
              )}
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setModalShowAmount(false);
              handleClearData(); // Clear the data
            }}
          >
            Close
          </Button>
          <Button variant="success" onClick={handleSubmit(onSubmit)}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />

      <div className="upload-modal">
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          id="exampleModaldel"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h1 className="add-success text-center  mt-2">
                  Are you sure ?
                </h1>
                <p>
                  Do You Really Want to Delete These Record?
                  <br /> This Process CanNot Be Undone{" "}
                </p>
                <div className="button-holder text-center mt-2">
                  <button className="btn btn-yes me-2" onClick={DeleteRecord}>
                    Yes
                  </button>
                  <button className="btn btn-no" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tables;
